export type CountryDialCode = {
  iso: string
  name: string
  dialCode: string
  localeRegions: string[]
  timeZones: string[]
}

export const DEFAULT_COUNTRY_ISO = 'ZA'

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
  { iso: 'AF', name: 'Afghanistan', dialCode: '+93', localeRegions: ['AF'], timeZones: [] },
  { iso: 'AL', name: 'Albania', dialCode: '+355', localeRegions: ['AL'], timeZones: [] },
  { iso: 'DZ', name: 'Algeria', dialCode: '+213', localeRegions: ['DZ'], timeZones: [] },
  { iso: 'AS', name: 'American Samoa', dialCode: '+1684', localeRegions: ['AS'], timeZones: [] },
  { iso: 'AD', name: 'Andorra', dialCode: '+376', localeRegions: ['AD'], timeZones: [] },
  { iso: 'AO', name: 'Angola', dialCode: '+244', localeRegions: ['AO'], timeZones: [] },
  { iso: 'AI', name: 'Anguilla', dialCode: '+1264', localeRegions: ['AI'], timeZones: [] },
  { iso: 'AQ', name: 'Antarctica', dialCode: '+672', localeRegions: ['AQ'], timeZones: [] },
  { iso: 'AG', name: 'Antigua and Barbuda', dialCode: '+1268', localeRegions: ['AG'], timeZones: [] },
  { iso: 'AR', name: 'Argentina', dialCode: '+54', localeRegions: ['AR'], timeZones: [] },
  { iso: 'AM', name: 'Armenia', dialCode: '+374', localeRegions: ['AM'], timeZones: [] },
  { iso: 'AW', name: 'Aruba', dialCode: '+297', localeRegions: ['AW'], timeZones: [] },
  {
    iso: 'AU',
    name: 'Australia',
    dialCode: '+61',
    localeRegions: ['AU'],
    timeZones: [
      'Australia/Sydney',
      'Australia/Melbourne',
      'Australia/Brisbane',
      'Australia/Perth',
      'Australia/Adelaide',
      'Australia/Darwin',
      'Australia/Hobart'
    ]
  },
  { iso: 'AT', name: 'Austria', dialCode: '+43', localeRegions: ['AT'], timeZones: [] },
  { iso: 'AZ', name: 'Azerbaijan', dialCode: '+994', localeRegions: ['AZ'], timeZones: [] },
  { iso: 'BS', name: 'Bahamas', dialCode: '+1242', localeRegions: ['BS'], timeZones: [] },
  { iso: 'BH', name: 'Bahrain', dialCode: '+973', localeRegions: ['BH'], timeZones: [] },
  { iso: 'BD', name: 'Bangladesh', dialCode: '+880', localeRegions: ['BD'], timeZones: [] },
  { iso: 'BB', name: 'Barbados', dialCode: '+1246', localeRegions: ['BB'], timeZones: [] },
  { iso: 'BY', name: 'Belarus', dialCode: '+375', localeRegions: ['BY'], timeZones: [] },
  { iso: 'BE', name: 'Belgium', dialCode: '+32', localeRegions: ['BE'], timeZones: [] },
  { iso: 'BZ', name: 'Belize', dialCode: '+501', localeRegions: ['BZ'], timeZones: [] },
  { iso: 'BJ', name: 'Benin', dialCode: '+229', localeRegions: ['BJ'], timeZones: [] },
  { iso: 'BM', name: 'Bermuda', dialCode: '+1441', localeRegions: ['BM'], timeZones: [] },
  { iso: 'BT', name: 'Bhutan', dialCode: '+975', localeRegions: ['BT'], timeZones: [] },
  { iso: 'BO', name: 'Bolivia', dialCode: '+591', localeRegions: ['BO'], timeZones: [] },
  { iso: 'BA', name: 'Bosnia and Herzegovina', dialCode: '+387', localeRegions: ['BA'], timeZones: [] },
  { iso: 'BW', name: 'Botswana', dialCode: '+267', localeRegions: ['BW'], timeZones: [] },
  { iso: 'BR', name: 'Brazil', dialCode: '+55', localeRegions: ['BR'], timeZones: [] },
  { iso: 'IO', name: 'British Indian Ocean Territory', dialCode: '+246', localeRegions: ['IO'], timeZones: [] },
  { iso: 'VG', name: 'British Virgin Islands', dialCode: '+1284', localeRegions: ['VG'], timeZones: [] },
  { iso: 'BN', name: 'Brunei', dialCode: '+673', localeRegions: ['BN'], timeZones: [] },
  { iso: 'BG', name: 'Bulgaria', dialCode: '+359', localeRegions: ['BG'], timeZones: [] },
  { iso: 'BF', name: 'Burkina Faso', dialCode: '+226', localeRegions: ['BF'], timeZones: [] },
  { iso: 'BI', name: 'Burundi', dialCode: '+257', localeRegions: ['BI'], timeZones: [] },
  { iso: 'KH', name: 'Cambodia', dialCode: '+855', localeRegions: ['KH'], timeZones: [] },
  { iso: 'CM', name: 'Cameroon', dialCode: '+237', localeRegions: ['CM'], timeZones: [] },
  { iso: 'CA', name: 'Canada', dialCode: '+1', localeRegions: ['CA'], timeZones: [] },
  { iso: 'CV', name: 'Cape Verde', dialCode: '+238', localeRegions: ['CV'], timeZones: [] },
  { iso: 'KY', name: 'Cayman Islands', dialCode: '+1345', localeRegions: ['KY'], timeZones: [] },
  { iso: 'CF', name: 'Central African Republic', dialCode: '+236', localeRegions: ['CF'], timeZones: [] },
  { iso: 'TD', name: 'Chad', dialCode: '+235', localeRegions: ['TD'], timeZones: [] },
  { iso: 'CL', name: 'Chile', dialCode: '+56', localeRegions: ['CL'], timeZones: [] },
  { iso: 'CN', name: 'China', dialCode: '+86', localeRegions: ['CN'], timeZones: [] },
  { iso: 'CX', name: 'Christmas Island', dialCode: '+61', localeRegions: ['CX'], timeZones: [] },
  { iso: 'CC', name: 'Cocos (Keeling) Islands', dialCode: '+61', localeRegions: ['CC'], timeZones: [] },
  { iso: 'CO', name: 'Colombia', dialCode: '+57', localeRegions: ['CO'], timeZones: [] },
  { iso: 'KM', name: 'Comoros', dialCode: '+269', localeRegions: ['KM'], timeZones: [] },
  { iso: 'CG', name: 'Congo', dialCode: '+242', localeRegions: ['CG'], timeZones: [] },
  { iso: 'CD', name: 'Congo (Democratic Republic)', dialCode: '+243', localeRegions: ['CD'], timeZones: [] },
  { iso: 'CK', name: 'Cook Islands', dialCode: '+682', localeRegions: ['CK'], timeZones: [] },
  { iso: 'CR', name: 'Costa Rica', dialCode: '+506', localeRegions: ['CR'], timeZones: [] },
  { iso: 'CI', name: "Cote d'Ivoire", dialCode: '+225', localeRegions: ['CI'], timeZones: [] },
  { iso: 'HR', name: 'Croatia', dialCode: '+385', localeRegions: ['HR'], timeZones: [] },
  { iso: 'CU', name: 'Cuba', dialCode: '+53', localeRegions: ['CU'], timeZones: [] },
  { iso: 'CW', name: 'Curacao', dialCode: '+599', localeRegions: ['CW'], timeZones: [] },
  { iso: 'CY', name: 'Cyprus', dialCode: '+357', localeRegions: ['CY'], timeZones: [] },
  { iso: 'CZ', name: 'Czech Republic', dialCode: '+420', localeRegions: ['CZ'], timeZones: [] },
  { iso: 'DK', name: 'Denmark', dialCode: '+45', localeRegions: ['DK'], timeZones: [] },
  { iso: 'DJ', name: 'Djibouti', dialCode: '+253', localeRegions: ['DJ'], timeZones: [] },
  { iso: 'DM', name: 'Dominica', dialCode: '+1767', localeRegions: ['DM'], timeZones: [] },
  { iso: 'DO', name: 'Dominican Republic', dialCode: '+1809', localeRegions: ['DO'], timeZones: [] },
  { iso: 'EC', name: 'Ecuador', dialCode: '+593', localeRegions: ['EC'], timeZones: [] },
  { iso: 'EG', name: 'Egypt', dialCode: '+20', localeRegions: ['EG'], timeZones: [] },
  { iso: 'SV', name: 'El Salvador', dialCode: '+503', localeRegions: ['SV'], timeZones: [] },
  { iso: 'GQ', name: 'Equatorial Guinea', dialCode: '+240', localeRegions: ['GQ'], timeZones: [] },
  { iso: 'ER', name: 'Eritrea', dialCode: '+291', localeRegions: ['ER'], timeZones: [] },
  { iso: 'EE', name: 'Estonia', dialCode: '+372', localeRegions: ['EE'], timeZones: [] },
  { iso: 'SZ', name: 'Eswatini', dialCode: '+268', localeRegions: ['SZ'], timeZones: [] },
  { iso: 'ET', name: 'Ethiopia', dialCode: '+251', localeRegions: ['ET'], timeZones: [] },
  { iso: 'FK', name: 'Falkland Islands', dialCode: '+500', localeRegions: ['FK'], timeZones: [] },
  { iso: 'FO', name: 'Faroe Islands', dialCode: '+298', localeRegions: ['FO'], timeZones: [] },
  { iso: 'FJ', name: 'Fiji', dialCode: '+679', localeRegions: ['FJ'], timeZones: [] },
  { iso: 'FI', name: 'Finland', dialCode: '+358', localeRegions: ['FI'], timeZones: [] },
  { iso: 'FR', name: 'France', dialCode: '+33', localeRegions: ['FR'], timeZones: ['Europe/Paris'] },
  { iso: 'GF', name: 'French Guiana', dialCode: '+594', localeRegions: ['GF'], timeZones: [] },
  { iso: 'PF', name: 'French Polynesia', dialCode: '+689', localeRegions: ['PF'], timeZones: [] },
  { iso: 'GA', name: 'Gabon', dialCode: '+241', localeRegions: ['GA'], timeZones: [] },
  { iso: 'GM', name: 'Gambia', dialCode: '+220', localeRegions: ['GM'], timeZones: [] },
  { iso: 'GE', name: 'Georgia', dialCode: '+995', localeRegions: ['GE'], timeZones: [] },
  { iso: 'DE', name: 'Germany', dialCode: '+49', localeRegions: ['DE'], timeZones: ['Europe/Berlin'] },
  { iso: 'GH', name: 'Ghana', dialCode: '+233', localeRegions: ['GH'], timeZones: [] },
  { iso: 'GI', name: 'Gibraltar', dialCode: '+350', localeRegions: ['GI'], timeZones: [] },
  { iso: 'GR', name: 'Greece', dialCode: '+30', localeRegions: ['GR'], timeZones: [] },
  { iso: 'GL', name: 'Greenland', dialCode: '+299', localeRegions: ['GL'], timeZones: [] },
  { iso: 'GD', name: 'Grenada', dialCode: '+1473', localeRegions: ['GD'], timeZones: [] },
  { iso: 'GP', name: 'Guadeloupe', dialCode: '+590', localeRegions: ['GP'], timeZones: [] },
  { iso: 'GU', name: 'Guam', dialCode: '+1671', localeRegions: ['GU'], timeZones: [] },
  { iso: 'GT', name: 'Guatemala', dialCode: '+502', localeRegions: ['GT'], timeZones: [] },
  { iso: 'GG', name: 'Guernsey', dialCode: '+44', localeRegions: ['GG'], timeZones: [] },
  { iso: 'GN', name: 'Guinea', dialCode: '+224', localeRegions: ['GN'], timeZones: [] },
  { iso: 'GW', name: 'Guinea-Bissau', dialCode: '+245', localeRegions: ['GW'], timeZones: [] },
  { iso: 'GY', name: 'Guyana', dialCode: '+592', localeRegions: ['GY'], timeZones: [] },
  { iso: 'HT', name: 'Haiti', dialCode: '+509', localeRegions: ['HT'], timeZones: [] },
  { iso: 'HN', name: 'Honduras', dialCode: '+504', localeRegions: ['HN'], timeZones: [] },
  { iso: 'HK', name: 'Hong Kong', dialCode: '+852', localeRegions: ['HK'], timeZones: [] },
  { iso: 'HU', name: 'Hungary', dialCode: '+36', localeRegions: ['HU'], timeZones: [] },
  { iso: 'IS', name: 'Iceland', dialCode: '+354', localeRegions: ['IS'], timeZones: [] },
  { iso: 'IN', name: 'India', dialCode: '+91', localeRegions: ['IN'], timeZones: ['Asia/Kolkata'] },
  { iso: 'ID', name: 'Indonesia', dialCode: '+62', localeRegions: ['ID'], timeZones: [] },
  { iso: 'IR', name: 'Iran', dialCode: '+98', localeRegions: ['IR'], timeZones: [] },
  { iso: 'IQ', name: 'Iraq', dialCode: '+964', localeRegions: ['IQ'], timeZones: [] },
  { iso: 'IE', name: 'Ireland', dialCode: '+353', localeRegions: ['IE'], timeZones: [] },
  { iso: 'IM', name: 'Isle of Man', dialCode: '+44', localeRegions: ['IM'], timeZones: [] },
  { iso: 'IL', name: 'Israel', dialCode: '+972', localeRegions: ['IL'], timeZones: [] },
  { iso: 'IT', name: 'Italy', dialCode: '+39', localeRegions: ['IT'], timeZones: [] },
  { iso: 'JM', name: 'Jamaica', dialCode: '+1876', localeRegions: ['JM'], timeZones: [] },
  { iso: 'JP', name: 'Japan', dialCode: '+81', localeRegions: ['JP'], timeZones: [] },
  { iso: 'JE', name: 'Jersey', dialCode: '+44', localeRegions: ['JE'], timeZones: [] },
  { iso: 'JO', name: 'Jordan', dialCode: '+962', localeRegions: ['JO'], timeZones: [] },
  { iso: 'KZ', name: 'Kazakhstan', dialCode: '+7', localeRegions: ['KZ'], timeZones: [] },
  { iso: 'KE', name: 'Kenya', dialCode: '+254', localeRegions: ['KE'], timeZones: [] },
  { iso: 'KI', name: 'Kiribati', dialCode: '+686', localeRegions: ['KI'], timeZones: [] },
  { iso: 'XK', name: 'Kosovo', dialCode: '+383', localeRegions: ['XK'], timeZones: [] },
  { iso: 'KW', name: 'Kuwait', dialCode: '+965', localeRegions: ['KW'], timeZones: [] },
  { iso: 'KG', name: 'Kyrgyzstan', dialCode: '+996', localeRegions: ['KG'], timeZones: [] },
  { iso: 'LA', name: 'Laos', dialCode: '+856', localeRegions: ['LA'], timeZones: [] },
  { iso: 'LV', name: 'Latvia', dialCode: '+371', localeRegions: ['LV'], timeZones: [] },
  { iso: 'LB', name: 'Lebanon', dialCode: '+961', localeRegions: ['LB'], timeZones: [] },
  { iso: 'LS', name: 'Lesotho', dialCode: '+266', localeRegions: ['LS'], timeZones: [] },
  { iso: 'LR', name: 'Liberia', dialCode: '+231', localeRegions: ['LR'], timeZones: [] },
  { iso: 'LY', name: 'Libya', dialCode: '+218', localeRegions: ['LY'], timeZones: [] },
  { iso: 'LI', name: 'Liechtenstein', dialCode: '+423', localeRegions: ['LI'], timeZones: [] },
  { iso: 'LT', name: 'Lithuania', dialCode: '+370', localeRegions: ['LT'], timeZones: [] },
  { iso: 'LU', name: 'Luxembourg', dialCode: '+352', localeRegions: ['LU'], timeZones: [] },
  { iso: 'MO', name: 'Macau', dialCode: '+853', localeRegions: ['MO'], timeZones: [] },
  { iso: 'MG', name: 'Madagascar', dialCode: '+261', localeRegions: ['MG'], timeZones: [] },
  { iso: 'MW', name: 'Malawi', dialCode: '+265', localeRegions: ['MW'], timeZones: [] },
  { iso: 'MY', name: 'Malaysia', dialCode: '+60', localeRegions: ['MY'], timeZones: [] },
  { iso: 'MV', name: 'Maldives', dialCode: '+960', localeRegions: ['MV'], timeZones: [] },
  { iso: 'ML', name: 'Mali', dialCode: '+223', localeRegions: ['ML'], timeZones: [] },
  { iso: 'MT', name: 'Malta', dialCode: '+356', localeRegions: ['MT'], timeZones: [] },
  { iso: 'MH', name: 'Marshall Islands', dialCode: '+692', localeRegions: ['MH'], timeZones: [] },
  { iso: 'MQ', name: 'Martinique', dialCode: '+596', localeRegions: ['MQ'], timeZones: [] },
  { iso: 'MR', name: 'Mauritania', dialCode: '+222', localeRegions: ['MR'], timeZones: [] },
  { iso: 'MU', name: 'Mauritius', dialCode: '+230', localeRegions: ['MU'], timeZones: [] },
  { iso: 'YT', name: 'Mayotte', dialCode: '+262', localeRegions: ['YT'], timeZones: [] },
  { iso: 'MX', name: 'Mexico', dialCode: '+52', localeRegions: ['MX'], timeZones: [] },
  { iso: 'FM', name: 'Micronesia', dialCode: '+691', localeRegions: ['FM'], timeZones: [] },
  { iso: 'MD', name: 'Moldova', dialCode: '+373', localeRegions: ['MD'], timeZones: [] },
  { iso: 'MC', name: 'Monaco', dialCode: '+377', localeRegions: ['MC'], timeZones: [] },
  { iso: 'MN', name: 'Mongolia', dialCode: '+976', localeRegions: ['MN'], timeZones: [] },
  { iso: 'ME', name: 'Montenegro', dialCode: '+382', localeRegions: ['ME'], timeZones: [] },
  { iso: 'MS', name: 'Montserrat', dialCode: '+1664', localeRegions: ['MS'], timeZones: [] },
  { iso: 'MA', name: 'Morocco', dialCode: '+212', localeRegions: ['MA'], timeZones: [] },
  { iso: 'MZ', name: 'Mozambique', dialCode: '+258', localeRegions: ['MZ'], timeZones: [] },
  { iso: 'MM', name: 'Myanmar', dialCode: '+95', localeRegions: ['MM'], timeZones: [] },
  { iso: 'NA', name: 'Namibia', dialCode: '+264', localeRegions: ['NA'], timeZones: [] },
  { iso: 'NR', name: 'Nauru', dialCode: '+674', localeRegions: ['NR'], timeZones: [] },
  { iso: 'NP', name: 'Nepal', dialCode: '+977', localeRegions: ['NP'], timeZones: [] },
  { iso: 'NL', name: 'Netherlands', dialCode: '+31', localeRegions: ['NL'], timeZones: ['Europe/Amsterdam'] },
  { iso: 'NC', name: 'New Caledonia', dialCode: '+687', localeRegions: ['NC'], timeZones: [] },
  { iso: 'NZ', name: 'New Zealand', dialCode: '+64', localeRegions: ['NZ'], timeZones: ['Pacific/Auckland', 'Pacific/Chatham'] },
  { iso: 'NI', name: 'Nicaragua', dialCode: '+505', localeRegions: ['NI'], timeZones: [] },
  { iso: 'NE', name: 'Niger', dialCode: '+227', localeRegions: ['NE'], timeZones: [] },
  { iso: 'NG', name: 'Nigeria', dialCode: '+234', localeRegions: ['NG'], timeZones: [] },
  { iso: 'NU', name: 'Niue', dialCode: '+683', localeRegions: ['NU'], timeZones: [] },
  { iso: 'NF', name: 'Norfolk Island', dialCode: '+672', localeRegions: ['NF'], timeZones: [] },
  { iso: 'KP', name: 'North Korea', dialCode: '+850', localeRegions: ['KP'], timeZones: [] },
  { iso: 'MK', name: 'North Macedonia', dialCode: '+389', localeRegions: ['MK'], timeZones: [] },
  { iso: 'MP', name: 'Northern Mariana Islands', dialCode: '+1670', localeRegions: ['MP'], timeZones: [] },
  { iso: 'NO', name: 'Norway', dialCode: '+47', localeRegions: ['NO'], timeZones: [] },
  { iso: 'OM', name: 'Oman', dialCode: '+968', localeRegions: ['OM'], timeZones: [] },
  { iso: 'PK', name: 'Pakistan', dialCode: '+92', localeRegions: ['PK'], timeZones: [] },
  { iso: 'PW', name: 'Palau', dialCode: '+680', localeRegions: ['PW'], timeZones: [] },
  { iso: 'PS', name: 'Palestine', dialCode: '+970', localeRegions: ['PS'], timeZones: [] },
  { iso: 'PA', name: 'Panama', dialCode: '+507', localeRegions: ['PA'], timeZones: [] },
  { iso: 'PG', name: 'Papua New Guinea', dialCode: '+675', localeRegions: ['PG'], timeZones: [] },
  { iso: 'PY', name: 'Paraguay', dialCode: '+595', localeRegions: ['PY'], timeZones: [] },
  { iso: 'PE', name: 'Peru', dialCode: '+51', localeRegions: ['PE'], timeZones: [] },
  { iso: 'PH', name: 'Philippines', dialCode: '+63', localeRegions: ['PH'], timeZones: [] },
  { iso: 'PL', name: 'Poland', dialCode: '+48', localeRegions: ['PL'], timeZones: [] },
  { iso: 'PT', name: 'Portugal', dialCode: '+351', localeRegions: ['PT'], timeZones: [] },
  { iso: 'PR', name: 'Puerto Rico', dialCode: '+1787', localeRegions: ['PR'], timeZones: [] },
  { iso: 'QA', name: 'Qatar', dialCode: '+974', localeRegions: ['QA'], timeZones: [] },
  { iso: 'RE', name: 'Reunion', dialCode: '+262', localeRegions: ['RE'], timeZones: [] },
  { iso: 'RO', name: 'Romania', dialCode: '+40', localeRegions: ['RO'], timeZones: [] },
  { iso: 'RU', name: 'Russia', dialCode: '+7', localeRegions: ['RU'], timeZones: [] },
  { iso: 'RW', name: 'Rwanda', dialCode: '+250', localeRegions: ['RW'], timeZones: [] },
  { iso: 'BL', name: 'Saint Barthelemy', dialCode: '+590', localeRegions: ['BL'], timeZones: [] },
  { iso: 'SH', name: 'Saint Helena', dialCode: '+290', localeRegions: ['SH'], timeZones: [] },
  { iso: 'KN', name: 'Saint Kitts and Nevis', dialCode: '+1869', localeRegions: ['KN'], timeZones: [] },
  { iso: 'LC', name: 'Saint Lucia', dialCode: '+1758', localeRegions: ['LC'], timeZones: [] },
  { iso: 'MF', name: 'Saint Martin', dialCode: '+590', localeRegions: ['MF'], timeZones: [] },
  { iso: 'PM', name: 'Saint Pierre and Miquelon', dialCode: '+508', localeRegions: ['PM'], timeZones: [] },
  { iso: 'VC', name: 'Saint Vincent and the Grenadines', dialCode: '+1784', localeRegions: ['VC'], timeZones: [] },
  { iso: 'WS', name: 'Samoa', dialCode: '+685', localeRegions: ['WS'], timeZones: [] },
  { iso: 'SM', name: 'San Marino', dialCode: '+378', localeRegions: ['SM'], timeZones: [] },
  { iso: 'ST', name: 'Sao Tome and Principe', dialCode: '+239', localeRegions: ['ST'], timeZones: [] },
  { iso: 'SA', name: 'Saudi Arabia', dialCode: '+966', localeRegions: ['SA'], timeZones: [] },
  { iso: 'SN', name: 'Senegal', dialCode: '+221', localeRegions: ['SN'], timeZones: [] },
  { iso: 'RS', name: 'Serbia', dialCode: '+381', localeRegions: ['RS'], timeZones: [] },
  { iso: 'SC', name: 'Seychelles', dialCode: '+248', localeRegions: ['SC'], timeZones: [] },
  { iso: 'SL', name: 'Sierra Leone', dialCode: '+232', localeRegions: ['SL'], timeZones: [] },
  { iso: 'SG', name: 'Singapore', dialCode: '+65', localeRegions: ['SG'], timeZones: [] },
  { iso: 'SX', name: 'Sint Maarten', dialCode: '+1721', localeRegions: ['SX'], timeZones: [] },
  { iso: 'SK', name: 'Slovakia', dialCode: '+421', localeRegions: ['SK'], timeZones: [] },
  { iso: 'SI', name: 'Slovenia', dialCode: '+386', localeRegions: ['SI'], timeZones: [] },
  { iso: 'SB', name: 'Solomon Islands', dialCode: '+677', localeRegions: ['SB'], timeZones: [] },
  { iso: 'SO', name: 'Somalia', dialCode: '+252', localeRegions: ['SO'], timeZones: [] },
  { iso: 'ZA', name: 'South Africa', dialCode: '+27', localeRegions: ['ZA'], timeZones: ['Africa/Johannesburg'] },
  { iso: 'KR', name: 'South Korea', dialCode: '+82', localeRegions: ['KR'], timeZones: [] },
  { iso: 'SS', name: 'South Sudan', dialCode: '+211', localeRegions: ['SS'], timeZones: [] },
  { iso: 'ES', name: 'Spain', dialCode: '+34', localeRegions: ['ES'], timeZones: ['Europe/Madrid', 'Atlantic/Canary'] },
  { iso: 'LK', name: 'Sri Lanka', dialCode: '+94', localeRegions: ['LK'], timeZones: [] },
  { iso: 'SD', name: 'Sudan', dialCode: '+249', localeRegions: ['SD'], timeZones: [] },
  { iso: 'SR', name: 'Suriname', dialCode: '+597', localeRegions: ['SR'], timeZones: [] },
  { iso: 'SJ', name: 'Svalbard and Jan Mayen', dialCode: '+47', localeRegions: ['SJ'], timeZones: [] },
  { iso: 'SE', name: 'Sweden', dialCode: '+46', localeRegions: ['SE'], timeZones: [] },
  { iso: 'CH', name: 'Switzerland', dialCode: '+41', localeRegions: ['CH'], timeZones: [] },
  { iso: 'SY', name: 'Syria', dialCode: '+963', localeRegions: ['SY'], timeZones: [] },
  { iso: 'TW', name: 'Taiwan', dialCode: '+886', localeRegions: ['TW'], timeZones: [] },
  { iso: 'TJ', name: 'Tajikistan', dialCode: '+992', localeRegions: ['TJ'], timeZones: [] },
  { iso: 'TZ', name: 'Tanzania', dialCode: '+255', localeRegions: ['TZ'], timeZones: [] },
  { iso: 'TH', name: 'Thailand', dialCode: '+66', localeRegions: ['TH'], timeZones: [] },
  { iso: 'TL', name: 'Timor-Leste', dialCode: '+670', localeRegions: ['TL'], timeZones: [] },
  { iso: 'TG', name: 'Togo', dialCode: '+228', localeRegions: ['TG'], timeZones: [] },
  { iso: 'TK', name: 'Tokelau', dialCode: '+690', localeRegions: ['TK'], timeZones: [] },
  { iso: 'TO', name: 'Tonga', dialCode: '+676', localeRegions: ['TO'], timeZones: [] },
  { iso: 'TT', name: 'Trinidad and Tobago', dialCode: '+1868', localeRegions: ['TT'], timeZones: [] },
  { iso: 'TN', name: 'Tunisia', dialCode: '+216', localeRegions: ['TN'], timeZones: [] },
  { iso: 'TR', name: 'Turkey', dialCode: '+90', localeRegions: ['TR'], timeZones: [] },
  { iso: 'TM', name: 'Turkmenistan', dialCode: '+993', localeRegions: ['TM'], timeZones: [] },
  { iso: 'TC', name: 'Turks and Caicos Islands', dialCode: '+1649', localeRegions: ['TC'], timeZones: [] },
  { iso: 'TV', name: 'Tuvalu', dialCode: '+688', localeRegions: ['TV'], timeZones: [] },
  { iso: 'VI', name: 'US Virgin Islands', dialCode: '+1340', localeRegions: ['VI'], timeZones: [] },
  { iso: 'UG', name: 'Uganda', dialCode: '+256', localeRegions: ['UG'], timeZones: [] },
  { iso: 'UA', name: 'Ukraine', dialCode: '+380', localeRegions: ['UA'], timeZones: [] },
  { iso: 'AE', name: 'United Arab Emirates', dialCode: '+971', localeRegions: ['AE'], timeZones: [] },
  { iso: 'GB', name: 'United Kingdom', dialCode: '+44', localeRegions: ['GB', 'UK'], timeZones: ['Europe/London'] },
  {
    iso: 'US',
    name: 'United States',
    dialCode: '+1',
    localeRegions: ['US'],
    timeZones: [
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Phoenix',
      'America/Los_Angeles',
      'America/Anchorage',
      'America/Adak',
      'Pacific/Honolulu'
    ]
  },
  { iso: 'UY', name: 'Uruguay', dialCode: '+598', localeRegions: ['UY'], timeZones: [] },
  { iso: 'UZ', name: 'Uzbekistan', dialCode: '+998', localeRegions: ['UZ'], timeZones: [] },
  { iso: 'VU', name: 'Vanuatu', dialCode: '+678', localeRegions: ['VU'], timeZones: [] },
  { iso: 'VA', name: 'Vatican City', dialCode: '+379', localeRegions: ['VA'], timeZones: [] },
  { iso: 'VE', name: 'Venezuela', dialCode: '+58', localeRegions: ['VE'], timeZones: [] },
  { iso: 'VN', name: 'Vietnam', dialCode: '+84', localeRegions: ['VN'], timeZones: [] },
  { iso: 'WF', name: 'Wallis and Futuna', dialCode: '+681', localeRegions: ['WF'], timeZones: [] },
  { iso: 'EH', name: 'Western Sahara', dialCode: '+212', localeRegions: ['EH'], timeZones: [] },
  { iso: 'YE', name: 'Yemen', dialCode: '+967', localeRegions: ['YE'], timeZones: [] },
  { iso: 'ZM', name: 'Zambia', dialCode: '+260', localeRegions: ['ZM'], timeZones: [] },
  { iso: 'ZW', name: 'Zimbabwe', dialCode: '+263', localeRegions: ['ZW'], timeZones: [] }
]

const getCountryByRegion = (region: string) => {
  const normalized = region.toUpperCase()
  return COUNTRY_DIAL_CODES.find((country) =>
    country.localeRegions.some((entry) => entry.toUpperCase() === normalized)
  )
}

const getRegionFromLocale = (locale: string) => {
  const match = locale.match(/-([a-z]{2})\b/i)
  return match?.[1]?.toUpperCase() ?? null
}

export const getCountryByIso = (iso: string) => {
  const normalized = iso.toUpperCase()
  return COUNTRY_DIAL_CODES.find((country) => country.iso.toUpperCase() === normalized)
}

const normalizeDialCode = (dialCode: string) => dialCode.replace(/[^\d+]/g, '')

export const getCountriesByDialCode = (dialCode: string) => {
  const normalized = normalizeDialCode(dialCode)
  return COUNTRY_DIAL_CODES.filter((country) => normalizeDialCode(country.dialCode) === normalized)
}

export const getCountryByDialCode = (dialCode: string) => {
  return getCountriesByDialCode(dialCode)[0]
}

export const getDefaultCountry = () => {
  return getCountryByIso(DEFAULT_COUNTRY_ISO) ?? COUNTRY_DIAL_CODES[0]
}

export const getDefaultDialCode = () => {
  return getDefaultCountry()?.dialCode ?? ''
}

const COUNTRY_SELECTION_STORAGE_PREFIX = 'irl-signup:country-selection'
export const COUNTRY_SELECTION_SOURCE = {
  auto: 'auto',
  manual: 'manual'
} as const

export type CountrySelectionSource = typeof COUNTRY_SELECTION_SOURCE[keyof typeof COUNTRY_SELECTION_SOURCE]
export type CountrySelectionScope = 'user' | 'company'

const isCountrySelectionSource = (value: string | null): value is CountrySelectionSource => {
  return value === COUNTRY_SELECTION_SOURCE.auto || value === COUNTRY_SELECTION_SOURCE.manual
}

const getCountrySelectionKey = (scope: CountrySelectionScope, field: 'source' | 'dialCode') => {
  return `${COUNTRY_SELECTION_STORAGE_PREFIX}:${scope}:${field}`
}

const getSessionStorage = () => {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return window.sessionStorage
  } catch (error) {
    console.error('Unable to access session storage for country selection.', error)
    return null
  }
}

export const readCountrySelectionSource = (scope: CountrySelectionScope): CountrySelectionSource | null => {
  const storage = getSessionStorage()
  if (!storage) {
    return null
  }
  try {
    const value = storage.getItem(getCountrySelectionKey(scope, 'source'))
    return isCountrySelectionSource(value) ? value : null
  } catch (error) {
    console.error('Unable to read country selection source.', error)
    return null
  }
}

export const writeCountrySelectionSource = (scope: CountrySelectionScope, source: CountrySelectionSource) => {
  const storage = getSessionStorage()
  if (!storage) {
    return
  }
  try {
    storage.setItem(getCountrySelectionKey(scope, 'source'), source)
  } catch (error) {
    console.error('Unable to write country selection source.', error)
  }
}

export const readStoredCountryDialCode = (scope: CountrySelectionScope) => {
  const storage = getSessionStorage()
  if (!storage) {
    return null
  }
  try {
    const rawValue = storage.getItem(getCountrySelectionKey(scope, 'dialCode'))
    if (!rawValue) {
      return null
    }
    const normalized = normalizeDialCode(rawValue)
    return normalized ? normalized : null
  } catch (error) {
    console.error('Unable to read stored country dial code.', error)
    return null
  }
}

export const writeStoredCountryDialCode = (scope: CountrySelectionScope, dialCode: string) => {
  const storage = getSessionStorage()
  if (!storage) {
    return
  }
  const normalized = normalizeDialCode(dialCode)
  if (!normalized) {
    return
  }
  try {
    storage.setItem(getCountrySelectionKey(scope, 'dialCode'), normalized)
  } catch (error) {
    console.error('Unable to write stored country dial code.', error)
  }
}

const guessFromLocales = (locales: readonly string[] | undefined) => {
  if (!locales?.length) {
    return null
  }

  for (const locale of locales) {
    const region = getRegionFromLocale(locale)
    if (!region) {
      continue
    }
    const country = getCountryByRegion(region)
    if (country) {
      return country.iso
    }
  }

  return null
}

const guessFromTimeZone = (timeZone: string | undefined) => {
  if (!timeZone) {
    return null
  }

  const match = COUNTRY_DIAL_CODES.find((country) => country.timeZones.includes(timeZone))
  return match?.iso ?? null
}

export const guessCountryIso = ({
  locales,
  timeZone
}: {
  locales?: readonly string[]
  timeZone?: string
}) => {
  const fromTimeZone = guessFromTimeZone(timeZone)
  if (fromTimeZone) {
    return fromTimeZone
  }

  const fromLocales = guessFromLocales(locales)
  if (fromLocales) {
    return fromLocales
  }

  return DEFAULT_COUNTRY_ISO
}

export const splitPhoneNumber = (e164: string): { dialCode: string; nationalNumber: string } => {
  if (!e164.startsWith('+')) {
    return { dialCode: '', nationalNumber: e164 }
  }

  // Sort dial codes by length descending to match the longest one (e.g., +1684 before +1)
  const sortedCodes = [...COUNTRY_DIAL_CODES].sort((a, b) => b.dialCode.length - a.dialCode.length)

  for (const country of sortedCodes) {
    if (e164.startsWith(country.dialCode)) {
      return {
        dialCode: country.dialCode,
        nationalNumber: e164.substring(country.dialCode.length)
      }
    }
  }

  return { dialCode: '', nationalNumber: e164 }
}
